module.exports = __webpack_public_path__ + "img/trilce.7896b933.jpg";